import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes"; // Add your route string here if needed

export const createReview = async (payload) => {
  const response = await apiService.post(`${apiRoutes.createReview}`, payload);
  return response.data;
};

export const updateReview = async (payload, reviewId) => {
  const response = await apiService.put(
    `${apiRoutes.updateReview}/${reviewId}`,
    payload
  );
  return response.data;
};

export const verifyReview = async (payload) => {
  const response = await apiService.post(`${apiRoutes.verifyReview}`, payload);
  return response.data;
};

export const fetchReviewList = async ({
  catId = "",
  userId = "",
  page = 1,
  limit = 10,
}) => {
  const params = new URLSearchParams({
    userId,
    catId,
    page: page.toString(),
    limit: limit.toString(),
  });
  const response = await apiService.get(
    `${apiRoutes.reviewList}?${params.toString()}`
  );
  return response.data;
};

export const fetchSingleReview = async ({ reviewId = "" }) => {
  const response = await apiService.get(`${apiRoutes.reviewById}/${reviewId}`);
  return response.data;
};

export const deleteReview = async ({ reviewId }) => {
  const response = await apiService.delete(
    `${apiRoutes.deleteReview}/${reviewId}`
  );
  return response.data;
};

export const addCommentReview = async (payload) => {
  const response = await apiService.post(`${apiRoutes.reviewReply}`, payload);
  return response.data;
};

export const addDisputeCommentReview = async (payload) => {
  const response = await apiService.post(
    `${apiRoutes.addDisputeCommentReview}`,
    payload
  );
  return response.data;
};

export const fetchProductReviews = async ({
  search="",
  productId = "",
  tag = "",
  userId = "",
  reviewId = "",
  page = 1,
  limit = 10,
  star=""
}) => {
  const params = new URLSearchParams({
    search,
    userId,
    productId,
    reviewId,
    tag,
    star,
    page: page.toString(),
    limit: limit.toString(),
  });
  const response = await apiService.get(
    `${apiRoutes.reviewList}?${params.toString()}`
  );
  return response.data;
};

export const getReviewAllReply = async ({
  search = "",
  reviewId,
  page,
  limit,
}) => {
  const params = new URLSearchParams({
    search,
    reviewId,
    page: page.toString(),
    limit: limit.toString(),
  });
  const response = await apiService.get(
    `${apiRoutes.reviewReply}?${params.toString()}`
  );
  return response.data;
};

export const getReviewAllDispute = async ({
  search = "",
  dateRange="",
  userId="",
  productId="",
  reviewId="",
  disputeId="",
  page,
  limit,
}) => {
  const params = new URLSearchParams({
    search,
    productId,
    dateRange,
    userId,
    disputeId,
    reviewId,
    page: page.toString(),
    limit: limit.toString(),
  });
  const response = await apiService.get(
    `${apiRoutes.addDisputeCommentReview}?${params.toString()}`
  );
  return response.data;
};

export const updateReviewDispute = async (payload,disputeId) => {
  const response = await apiService.put(
    `${apiRoutes.addDisputeCommentReview}/${disputeId}`,payload
  );
  return response.data;
};


export const deleteReviewDispute = async ({disputeId}) => {
  const response = await apiService.delete(
    `${apiRoutes.addDisputeCommentReview}/${disputeId}`
  );
  return response.data;
};